<template>
	<div class="lv-table-column-controller">
		<lv-column-group ref="group" is-ctrl-group>
			<slot></slot>
		</lv-column-group>
	</div>
</template>

<script>
	import LvColumnGroup from "./lv-column-group";

	export default {
		name: "lv-table-column-controller",
		components: {LvColumnGroup},
		data() {
			return {
				observer: new MutationObserver(() => this.pl_detect()),
				timer: null,
			}
		},
		mounted() {
			this.collect()
			this.observer.observe(this.$el, {childList: true, subtree: true})
		},
		methods: {
			collect() {
				if (!this.$refs.group) {
					return
				}
				const columns = this.$refs.group.col().children
				let hasFixedLeft = false
				let hasFixedRight = false
				columns.forEach(col => {
					col.fixed === 'left' && (hasFixedLeft = true)
					col.fixed === 'right' && (hasFixedRight = true)
				})
				columns.forEach(col => {
					hasFixedLeft && col.placeLeft && (col.fixed = 'left')
					hasFixedRight && col.placeRight && (col.fixed = 'right')
				})
				this.$emit('collect', columns)
			},
			pl_detect() {
				this.collect()
			},
			pl_refresh() {
				if (!!this.timer) {
					clearTimeout(this.timer)
					this.timer = null
				}
				this.timer = setTimeout(() => this.collect(), 100)
			},
		}
	}
</script>

<style lang="scss">
	.lv-table-column-controller {
		display: none;
	}
</style>
